export default __webpack_public_path__ + "static/media/newOrder.ea97b9cd.mp3";